import { getToken } from '@/utils/auth'
import CryptoJS from 'crypto-js'
import cache from '@/utils/cache'
import { currentDomain } from '@/utils/domain'
import store from '../store'
import Vue from 'vue'
let instance = null

class WebSocketManager {
  constructor() {
    if (instance) return instance
    instance = this

    // 初始化属性
    this.webSocket = null
    this.timer = null
    this.reconnectTimer = null
    this.reconnectCount = 0
    this.maxReconnectCount = 3 // 最大重试次数
    this.baseReconnectDelay = 3000 // 基础重连延迟(ms)
    this.isLoading = false
    this.list = [] // 消息列表
     
  }

  // 初始化WebSocket（核心方法）
  async init( ) {
    const userInfo =  store.getters.userInfo.boxUserId
    
    if (!userInfo) {
      console.error('WebSocket初始化失败：用户信息为空')
      return
    }

    // 避免重复初始化
    if (this.webSocket) {
      console.log('WebSocket已存在，无需重复初始化')
      return
    }

    this.isLoading = true
    try {
      await this.createWebSocket()
    } catch (e) {
      console.error('WebSocket初始化异常：', e)
      this.isLoading = false
      this.reconnect()
    }
  }

  // 创建WebSocket连接
  createWebSocket() {
    return new Promise((resolve, reject) => {
      const boxUserId = store.getters.userInfo.boxUserId
      const token = getToken()

      // 校验必要参数
      if (!boxUserId || !token) {
        reject(new Error('缺少boxUserId或token'))
        return
      }

      // 生成签名
      const timestamp = Date.now()
      const nonce = Math.random().toString(36).slice(2)
      const raw = `${boxUserId}:${timestamp}:${nonce}`
      const sign = CryptoJS.HmacSHA256(raw, token).toString()
      const gateNos = cache.session.getJSON('selectParkList')?.flatMap(item => item.gates).map(gate => gate.gateNo).join(',') || ''

      // 拼接WS地址
      const url = `${currentDomain.ws}/ws/box?boxUserId=${boxUserId}&token=${token}&timestamp=${timestamp}&nonce=${nonce}&sign=${sign}&gateNos=${gateNos}`
      
      // 创建WebSocket实例
      this.webSocket = new WebSocket(url)
      
      // const vueInstance = new Vue()
      // const $root = vueInstance.$root
      // console.log($root)
      // if ($root) {
      //   $root.$ws = this.webSocket
      //   $root.sendWsMsg = this.sendWsMsg.bind(this)
      // }

      // 绑定事件
      this.webSocket.onopen = (res) => {
        this.webSocketOnOpen(res)
        resolve(res)
      }
      this.webSocket.onclose = (res) => this.webSocketOnClose(res)
      this.webSocket.onmessage = (res) => this.webSocketOnMessage(res)
      this.webSocket.onerror = (res) => {
        this.webSocketOnError(res)
        reject(res)
      }
    })
  }
 
  sendWsMsg(msg) {
    console.log(msg)
    try {
      if (!this.webSocket) {
        console.error('WebSocket实例未初始化')
        return false
      }
      if (this.webSocket.readyState !== WebSocket.OPEN) {
        console.error('WebSocket未连接成功，当前状态：', this.webSocket.readyState)
        return false
      }
      const sendData = typeof msg === 'object' ? JSON.stringify(msg) : msg
      this.webSocket.send(sendData)
      return true
    } catch (e) {
      console.error('WebSocket消息发送失败：', e)
      return false
    }
  }

  // 连接成功回调
  webSocketOnOpen(res) {
    console.log('WebSocket连接成功', res)
    this.isLoading = false
    this.reconnectCount = 0 // 重置重试次数
    clearTimeout(this.reconnectTimer)
  }

  // 消息接收回调
  webSocketOnMessage(res) {
    try {
      const data = JSON.parse(res.data)
      const detail = data.data
      Vue.prototype.$bus.$emit('getMsg', detail)
    } catch (e) {
      console.error('解析WebSocket消息失败:', e)
    }
  }
 
  webSocketOnClose(res) {
    console.log('WebSocket连接关闭，状态码:', res.code, '原因:', res.reason)
    this.list = []
    // 非正常关闭才重连
    if (![1000, 1001].includes(res.code)) {
      this.reconnect()
    }
  }

  // 连接错误回调
  webSocketOnError(res) {
    console.error('WebSocket连接错误:', res)
    this.isLoading = false
    this.list = []
    this.reconnect()
  }

  // 智能重连（指数退避算法）
  reconnect() {
    clearTimeout(this.reconnectTimer)

    // 超过最大重试次数停止
    if (this.reconnectCount >= this.maxReconnectCount) {
      console.error(`WebSocket重连${this.maxReconnectCount}次失败，停止重连，请手动刷新页面`)
      this.isLoading = false
      return
    }
   
    const delay = this.baseReconnectDelay * Math.pow(2, this.reconnectCount)
    console.log(`WebSocket准备重连，第${this.reconnectCount + 1}次，延迟${delay}ms`)

    this.reconnectTimer = setTimeout(() => {
      this.reconnectCount++
      this.createWebSocket() // 重新创建连接
    }, delay)
  }
 
  // 销毁WebSocket连接（登出时调用）
  destroy() {
    clearTimeout(this.timer)
    clearTimeout(this.reconnectTimer)
    if (this.webSocket) {
      try {
        this.webSocket.close(1001, '主动销毁连接')
      } catch (e) {
        console.warn('关闭WebSocket失败:', e)
      }
      this.webSocket = null
    }
    this.list = []
    this.reconnectCount = 0
    this.isLoading = false
    
    this.$bus?.$off('changeRoadBox1')
    this.$bus?.$off('changeRoad')
  }
}

// 导出单例实例
export default new WebSocketManager()